import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const identificationDocument = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    documentNumber: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Document number (e.g. AZE000000 for local, GER00000000 for international).',
      ),

    pinCode: z
      .string()
      .nullable()
      .optional()
      .describe('PIN code for local candidates.'),

    issuingAuthority: z
      .string()
      .nullable()
      .optional()
      .describe('Issuing authority.'),

    dateOfIssue: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Date of issue.'),

    dateOfExpiry: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Date of expiry.'),

    visaNumber: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Existing Azerbaijani visa number for international applicants.',
      ),

    visaExpirationDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Visa expiration date for international applicants.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    candidate: belongsTo('Candidate'),
  })
  .describe('Passport and visa details for a candidate.')
  .as('IdentificationDocument');

export { identificationDocument as identificationDocumentSchema };
